<template>
  <div id="app">
    <div class="dana-cepat-menu-box" v-if="screenWidth > 750">
      <div class="dana-cepat-log-box">
        <img src="@/assets/logo.png" alt="">
        <span>AmanCepat </span>
      </div>
      <div class="dana-cepat-menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'dana-cepat-choice' : ''">Beranda</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'dana-cepat-choice' : ''">Fitur</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'dana-cepat-choice' : ''">Cara penggunaan</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'dana-cepat-choice' : ''">Kebijakan Privasi</div>
        <div @click="choiceMenu(5)" :class="(menuIndex === 5) ? 'dana-cepat-choice' : ''">Mengenai kami</div>
      </div>
    </div>
    <div id="home"></div>
    <div class="product" id="product">
      <p class="logoname">Profesional, Aman, Mudah ? <span></span></p>
      <p class="logomsg">AmanCepat merupakan produk perwakilan Koperasi Simpan Pinjam Coinku Indonesia yang dapat membantu anggota mengajukan pinjaman dengan lebih mudah dan menyediakan produk yang dapat memenuhi berbagai kebutuhan anggota.
      </p>
      <!-- <a href="https://play.google.com/store/apps/details?id=com.kita.emas" class="googlelogo"></a> -->
      <img class="kspt" src="../assets/ksp.png" alt="">
    </div>
    <div id="step_1"></div>
    <div class="features" id="features">
      <h2 class="title">Fitur Produk<span></span></h2>
      <div class="cards">
        <div class="left">
          <div class="card">
            <h5>Koperasi Memperkuat Ekonomi Anggotanya</h5>
          </div>
          <div class="card">
            <h5>Koperasi Sebagai Tempat Mendapatkan Modal Usaha</h5>
          </div>
          <div class="card">
            <h5>Koperasi Memperbaiki Pertumbuhan ekonomi</h5>
          </div>
          <div class="card">
            <h5>Koperasi Sebagai Tempat Penyimpanan Uang</h5>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div id="step_2"></div>
    <div class="how" id="how">
      <h2 class="title">Cara penggunaan : <span></span></h2>
      <div class="howBox">
        <div class="left">
          <div class="item">
            <p>1. Unduh AmanCepat di Google Play dan buat akun pribadi.</p>
          </div>

          <div class="item">
            <p>3. Setelah pengguna memilih produk, ikuti langkah-langkah untuk mengisi informasi yang relevan dan mengirimkannya untuk melakukan pengajuan pinjaman.</p>
          </div>
        </div>
        <div class="middle"></div>
        <div class="right">
          <div class="item">
            <p>2. Mendaftar sebagai anggota Koperasi Simpan Pinjam Coinku Indonesia</p>
          </div>
          <div class="item">
            <p>4. Setelah pengajuan pinjaman disetujui, pihak pemberi pinjaman akan mengirimkan dana tersebut ke rekening bank yang diberikan oleh pengguna.</p>
          </div>
        </div>
      </div>

    </div>
    <div id="step_3"></div>
    <div class="policy" id="policy" :style="showMenu ? '' : 'height:auto;'">
      <p class="seemore"> <span @click='menuClick()'></span> </p>
      <h2 class="title">Kebijakan Privasi<span></span></h2>

      <div class="msgs" :style="showMenu ? '' : 'height:auto;'">
        <privacy :isTitle="false"></privacy>
      </div>
    </div>
    <div id="step_4"></div>
    <div class="about" id="about">
      <h2 class="title">Mengenai kami :<span></span></h2>
      <p>
        AmanCepat adalah aplikasi yang dikembangkan oleh Koperasi Simpan Pinjam Coinku Indonesia untuk membantu anggota memenuhi kebutuhan keuangan mereka dan membantu anggota dalam mengajukan pinjaman di Koperasi Simpan Pinjam Coinku Indonesia.
      </p>
    </div>
    <div id="step_5"></div>
    <footer class="bottom">
      <p><img src="../assets/ksp.png" class="ksp"></p>
      <p>
        <img src="../assets/address.png" class="icon">
        JAWA BARAT,KOTA BANDUNG,SUKASARI,Sarimanis 7 no 106
      </p>
      <p>
        <img src="../assets/email.png" class="icon">
        foam@federalinternationalfinance.com
      </p>
    </footer>
    <footer>Copyright © 2023 AmanCepat</footer>


  </div>
</template>

<script>
import privacy from "@/components/privacy";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: true
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step_1").scrollIntoView(); break;
        case 2: document.getElementById("step_2").scrollIntoView(); break;
        case 3: document.getElementById("step_3").scrollIntoView(); break;
        case 4: document.getElementById("step_4").scrollIntoView(); break;
        case 5: document.getElementById("step_5").scrollIntoView(); break;
        case 6: document.getElementById("dana-cepat-footer").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    }
  }
}
</script>


<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
